
// export default "https://pandafu.lz06.com/server";
export default "https://api.ec.lz06.com/xiongmao";